import { useField } from 'formik';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from 'react-tooltip';
import PropTypes from 'prop-types';

const SelectStyled = styled(Dropdown)`
    width: 100%;
`;

const Div = styled.div`
    color: red;
`;

const Asterisk = styled.span`
    color: red;
    margin-left: 4px;
`;

const Label = styled.label`
    font-weight: bold;
`;

const SelectInput = ({ label, tooltipContent, required, fetchOptions, ...props }) => {
    const [field, meta, helpers] = useField(props);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const loadOptions = async () => {
            try {
                const data = await fetchOptions();
                setOptions(data.map((item) => ({ label: item.nombre, value: item.id })));
            } catch (error) {
                console.error("Error fetching options:", error);
            }
        };
        loadOptions();
    }, [fetchOptions]);

    return (
        <div style={{ width: '100%' }}>
            <Label>
                {label}
                {required && <Asterisk>*</Asterisk>}
            </Label>
            <br />
            <SelectStyled
                {...field}
                {...props}
                value={field.value}
                options={options}
                onChange={(e) => helpers.setValue(e.value)}
                data-tooltip-id="my-tooltipSelect"
                data-tooltip-content={tooltipContent}
                placeholder="Seleccione una opción"
            />
            <Tooltip id="my-tooltipSelect" place="bottom" />
            {meta.touched && meta.error ? <Div>{meta.error}</Div> : null}
        </div>
    );
};

SelectInput.propTypes = {
    label: PropTypes.string.isRequired,
    tooltipContent: PropTypes.string,
    required: PropTypes.bool,
    fetchOptions: PropTypes.func.isRequired,
};

export default SelectInput;
